const invoicingFilters = {
  invoiceFrequencyId: null,
  dateBegin: null,
  dateEnd: null,
  businessEntityId: null,
  clientId: null,
  showDetails: false
}

export default () => Object.assign({}, invoicingFilters)
